export const defaultPricingKeys = {
	all: ['defaultPricing'] as const,
	lists: () => [...defaultPricingKeys.all, 'list'] as const,
	list: (filters?: any) => [...defaultPricingKeys.lists(), filters ?? {}] as const,
	details: () => [...defaultPricingKeys.all, 'detail'] as const,
	detail: (id: string) => [...defaultPricingKeys.details(), id] as const,
};
